import { format } from 'date-fns';

export type DateTimeValue = string | Date | null | undefined;

export const parseDateTime = (value: DateTimeValue): Date | null => {
  if (value === null || value === undefined || value === '') return null;

  const parsed =
    value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatLocalDateTime = (
  value: DateTimeValue,
  pattern = 'dd/MM/yyyy HH:mm:ss',
  fallback = '--'
): string => {
  const parsed = parseDateTime(value);
  return parsed ? format(parsed, pattern) : fallback;
};
